import React from "react";
import HeaderButtonGroup from "../../components/header-button-group/HeaderButtonGroup";
import SubHeader from "../../components/sub-header/SubHeader";
import { FaSave, FaCloudDownloadAlt, FaTrash, FaCogs, FaFileAlt } from "react-icons/fa"; // Add FaTrash for delete button
import Upload from "baseui/icon/upload";
import { connect } from "react-redux";
import { updateModelRun, generateRun, updateAndGenerateModelRun } from "../../redux/model-run/ModelRunThunk";
import { deleteModeler } from "../../redux/modeler/ModelerThunk";
import Spinner from 'baseui/icon/spinner'
import { useEffect } from "react";
import useRouteParams from "../../hooks/useRouteParams";
import * as GlobalConstants from "../../constants/GlobalConstants";
import { StyledLink } from "baseui/link";
import { withStyle } from "baseui";

const CustomLink = withStyle(StyledLink, {
  color: "#d0d0d0", // A light gray color
  fontWeight: "500",
  fontSize: "14px",
  padding: "8px 16px",
  borderRadius: "4px",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  transition: "all 0.2s ease",
  ":visited": {
    color: "#d0d0d0",
  },
  ":hover": {
    color: "#f0f0f0", // A slightly brighter gray for hover
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    textDecoration: "none",
  },
});

function ModelerSubHeaderView(props) {
  const { _, searchParams, searchPart } = useRouteParams();
  const [hasActiveRun, setHasActiveRun] = React.useState(props.hasActiveRun);


  useEffect(() => {
    setHasActiveRun(searchParams["runId"] !== undefined);
  }, [searchPart]);


  const onDeleteClick = () => {
    // Add logic to dispatch the deleteModeler action with activeModeler.modelerId as input
    props.onDeleteModeler(props.activeModeler?.id);
  };
  const subHeaderButtons = [
    {
      label: "Upload",
      icon: Upload,      
      clickAction: props.onUploadClick,
      style: hasActiveRun ? {} : { opacity: 0.9, disabled: true }, // Example of reducing opacity while loading
    }, 
    {
      label: "Delete",
      icon: props.deleteStatus === GlobalConstants.REQUEST_STATUS.STARTED ? Spinner : FaTrash,
      clickAction: onDeleteClick,
      style: props.deleteStatus === GlobalConstants.REQUEST_STATUS.STARTED || props.activeModeler?.templateId  ? { opacity: 0.9, disabled: true } : {},
    },        
  ];

  return (
    <SubHeader
      leftChildren={
        props.activeModeler?.generatedReportId ? (
          <CustomLink
            rel="noopener noreferrer"
            target="_blank"
            href={`${process.env.REACT_APP_REPORT_SITE_URL}/${props.activeModeler.generatedReportId}`}
          >
            <FaFileAlt style={{ marginRight: '8px' }} />
            View Report
          </CustomLink>
        ) : null
      }
      rightChildren={<HeaderButtonGroup buttons={subHeaderButtons} />}
    ></SubHeader>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedModelRun: state.modelRun.selectedModelRun,
    updateInProgress: state.modelRun.updateInProgress,
    activeModeler: state.modeler.activeModeler, // Assuming you have this in your redux state
    deleteStatus: state.modeler.deleteStatus, // Assuming you have this in your redux state
    generateInProgress: state.modelRun.generateInProgress,
    isDirty: state.modelRun?.selectedModelRun?.isDirty,
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSaveModelRun: (modelrun) => {
      dispatch(updateModelRun(modelrun));
    },
    onDeleteModeler: (modelerId) => {
      dispatch(deleteModeler(modelerId));
    },
    onGenerateRun: (modelerId, modelRunId) => {
      dispatch(generateRun(modelerId, modelRunId));
    },
    onUpdateAndGenerateRun: (modelerId, modelRunId, modelrun) => {
      dispatch(updateAndGenerateModelRun(modelerId, modelRunId, modelrun));
    },

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelerSubHeaderView);
